export default __webpack_public_path__ + "static/media/Ind-icon.07b33ec9.svg";